import { createStyles } from "@mantine/core";
import { colors } from "theme";

export const useStyles = createStyles(() => ({
  editButton: {
    fontWeight: 500,
    textDecoration: "none",
    justifySelf: "end",
    alignSelf: "start",
  },
  vehicleConditionGrid: {
    display: "grid",
    gap: "24px 8px",
    gridTemplateColumns: "auto auto",
  },
  answers: {
    justifySelf: "end",
  },
  horizontalLine: {
    width: "100%",
    height: "1px",
    background: colors.grey[10],
  },
  mileagePhoto: {
    gridTemplateColumns: "1fr",
  },
}));
